module.exports = __webpack_public_path__ + "static/media/primary-rightsmall.8da254c5.svg";